import { AgTechQueryParam, OdQueryParam } from "../enums";
import { helperFunctions } from "../helper";
import { IStakesAllResponse } from "../models";
import { URLConfig } from "../network";
import NetworkService from "../network/networkService";
import { Observable } from "rxjs";

export const getStakes = (
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<IStakesAllResponse> => {
  let url = URLConfig.getStakesURL();
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (productResponse: unknown) => {
        if (productResponse) {
          const productsResponse =
            productResponse as unknown as IStakesAllResponse;
          subscriber.next(productsResponse);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching products master data", error);
      }
    );
  });
};

export const getStakesNextPage = (
  nextPageURI: string
): Observable<IStakesAllResponse> => {
  let url = URLConfig.getStakesNextPageURL(nextPageURI);

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (productResponse) => {
        if (productResponse) {
          const productsResponse =
            productResponse as unknown as IStakesAllResponse;
          subscriber.next(productsResponse);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching products master data", error);
      }
    );
  });
};

export const previewFile = (payload: any): Observable<any> => {
  let url = URLConfig.getPreviewFileURL();
  return new Observable((subscriber) => {
    NetworkService.post(url, payload).then(
      (res: unknown) => {
        if (res) {
          subscriber.next(res);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching crops master data", error);
      }
    );
  });
};

export const getPrintFile = (payload: any,followUpUri: string): Observable<any> => {
  let url = URLConfig.getPrintJobFileURL();
  if(followUpUri?.length > 0 ){
    url=`${url}${followUpUri}`
  }
  
  return new Observable((subscriber) => {
    NetworkService.post(url, payload).then(
      (res: unknown) => {
        subscriber.next(res);
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while generate printing", error);
      }
    );
  });
};

export const getPrintJobStatus = (jobUrl: string): Observable<any> => {
  return new Observable((subscriber) => {
    const url = `${URLConfig.getReportingBaseURL()}${jobUrl}`;
    NetworkService.get(url).then(
      (res: unknown) => {
        subscriber.next(res);
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while generate printing", error);
      }
    );
  });
};
export const initiatePrintJob = (payload: any,
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: string[];
  }>): Observable<any> => {
  let url = URLConfig.getPrintJobFileURL();
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.post(url, payload).then(
      (res: unknown) => {
        subscriber.next(res);
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while generate printing", error);
      }
    );
  });
};

export const getJobFile = (
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: string[];
  }>
): Observable<any> => {
  let url = URLConfig.getPrintJobFileURL();
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          subscriber.next(res);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching crops master data", error);
      }
    );
  });
};

export const getJobFileNextPage = (nextPageUri: string): Observable<any> => {
  let url = URLConfig.getPrintJobFileNextPageURL(nextPageUri);
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          subscriber.next(res);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching crops master data", error);
      }
    );
  });
};

export const getContentLengthForStakes = (
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<number> => {
  let url = URLConfig.getStakesURL();
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching crops master data:", error);
      });
  });
};

export const getBarcodeInventories = (
  queryParams?: Array<{
    key: OdQueryParam | AgTechQueryParam;
    value: string[];
  }>
): Observable<IStakesAllResponse> => {
  let url = URLConfig.getBarcodeInventoryURL();
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: any) => {
        if (res) {
          subscriber.next(res);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching products master data", error);
      }
    );
  });
};
